import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.promise.js";
import _isFunction from "lodash/isFunction";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.is-array.js";
import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* eslint-disable dot-notation */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { Paper, Row, Col, Button, SignDocument, showSuccess } from 'components';
import { showApiError, convertToAdditionalCurrency } from 'utils';
import { activateCredit } from 'services';
import { list } from 'styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var PayOff = function PayOff(_ref) {
  var _credit$number, _credit$amount, _credit$amount_to_be_, _credit$amount2, _credit$fees, _credit$amount_to_be_2;

  var credit = _ref.credit,
      onActivate = _ref.onActivate;
  var history = useHistory();

  var _useState = useState('notSign'),
      _useState2 = _slicedToArray(_useState, 2),
      status = _useState2[0],
      setStatus = _useState2[1];

  var handleActivate = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$activateCredit, _yield$activateCredit2, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return activateCredit(credit === null || credit === void 0 ? void 0 : credit.id);

            case 2:
              _yield$activateCredit = _context.sent;
              _yield$activateCredit2 = _slicedToArray(_yield$activateCredit, 2);
              err = _yield$activateCredit2[1];

              if (!err) {
                _context.next = 7;
                break;
              }

              return _context.abrupt("return", showApiError(err));

            case 7:
              showSuccess('Кредита активиран успешно!');
              _isFunction(onActivate) && onActivate();
              setStatus('final');

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleActivate() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleGoToCredits = function handleGoToCredits() {
    return history.push('/credits');
  };

  return ___EmotionJSX(React.Fragment, null, status === 'notSign' || status === 'final' ? ___EmotionJSX(Paper, {
    header: "\u0418\u0437\u043F\u043B\u0430\u0442\u0438",
    margin: "2em 0"
  }, ___EmotionJSX("div", {
    css: list
  }, status === 'notSign' ? ___EmotionJSX(React.Fragment, null, ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u041D\u043E\u043C\u0435\u0440 "), ___EmotionJSX("p", {
    "data-value": "credit.number",
    className: "value"
  }, (_credit$number = credit === null || credit === void 0 ? void 0 : credit.number) !== null && _credit$number !== void 0 ? _credit$number : '--')), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u041E\u0431\u0449\u043E "), ___EmotionJSX("div", {
    className: "multi-price-wrap"
  }, ___EmotionJSX("p", {
    "data-value": "credit.amount",
    className: "value"
  }, "".concat((_credit$amount = credit === null || credit === void 0 ? void 0 : credit.amount) !== null && _credit$amount !== void 0 ? _credit$amount : '--', " ").concat(credit === null || credit === void 0 ? void 0 : credit.currency)), ___EmotionJSX("p", {
    className: "value"
  }, convertToAdditionalCurrency({
    value: credit === null || credit === void 0 ? void 0 : credit.amount,
    fromCurrency: credit === null || credit === void 0 ? void 0 : credit.currency
  })))), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0421\u0443\u043C\u0430 \u0437\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u0432\u0430\u043D\u0435 "), ___EmotionJSX("div", {
    className: "multi-price-wrap"
  }, ___EmotionJSX("p", {
    "data-value": "credit.amount_to_be_received_from_client",
    className: "value"
  }, "".concat((_credit$amount_to_be_ = credit === null || credit === void 0 ? void 0 : credit.amount_to_be_received_from_client) !== null && _credit$amount_to_be_ !== void 0 ? _credit$amount_to_be_ : '--', " ").concat(credit === null || credit === void 0 ? void 0 : credit.currency)), ___EmotionJSX("p", {
    className: "value"
  }, convertToAdditionalCurrency({
    value: credit === null || credit === void 0 ? void 0 : credit.amount_to_be_received_from_client,
    fromCurrency: credit === null || credit === void 0 ? void 0 : credit.currency
  }))))) : ___EmotionJSX(React.Fragment, null, ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0421\u0443\u043C\u0430 \u0437\u0430 \u0438\u0437\u043F\u043B\u0430\u0449\u0430\u043D\u0435 "), ___EmotionJSX("div", {
    className: "multi-price-wrap"
  }, ___EmotionJSX("p", {
    "data-value": "credit.amount",
    className: "value"
  }, "".concat((_credit$amount2 = credit === null || credit === void 0 ? void 0 : credit.amount) !== null && _credit$amount2 !== void 0 ? _credit$amount2 : '--', " ").concat(credit === null || credit === void 0 ? void 0 : credit.currency)), ___EmotionJSX("p", {
    className: "value"
  }, convertToAdditionalCurrency({
    value: credit === null || credit === void 0 ? void 0 : credit.amount,
    fromCurrency: credit === null || credit === void 0 ? void 0 : credit.currency
  })))), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0422\u0430\u043A\u0441\u0438 "), ___EmotionJSX("div", {
    className: "multi-price-wrap"
  }, ___EmotionJSX("p", {
    "data-value": "credit.fees",
    className: "value"
  }, "".concat((_credit$fees = credit === null || credit === void 0 ? void 0 : credit.fees) !== null && _credit$fees !== void 0 ? _credit$fees : '--', " ").concat(credit === null || credit === void 0 ? void 0 : credit.currency)), ___EmotionJSX("p", {
    className: "value"
  }, convertToAdditionalCurrency({
    value: credit === null || credit === void 0 ? void 0 : credit.fees,
    fromCurrency: credit === null || credit === void 0 ? void 0 : credit.currency
  })))), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0420\u0430\u0437\u043B\u0438\u043A\u0430 "), ___EmotionJSX("div", {
    className: "multi-price-wrap"
  }, ___EmotionJSX("p", {
    "data-value": "credit.amount_to_be_received_from_client",
    className: "value"
  }, "".concat((_credit$amount_to_be_2 = credit === null || credit === void 0 ? void 0 : credit.amount_to_be_received_from_client) !== null && _credit$amount_to_be_2 !== void 0 ? _credit$amount_to_be_2 : '--', " ").concat(credit === null || credit === void 0 ? void 0 : credit.currency)), ___EmotionJSX("p", {
    className: "value"
  }, convertToAdditionalCurrency({
    value: credit === null || credit === void 0 ? void 0 : credit.amount_to_be_received_from_client,
    fromCurrency: credit === null || credit === void 0 ? void 0 : credit.currency
  })))))), ___EmotionJSX(Row, {
    margin: "2em 0 0 0"
  }, ___EmotionJSX(Col, {
    displayFlex: true,
    md: true,
    justify: "flex-end"
  }, ___EmotionJSX(Button, {
    type: "secondary",
    onClick: handleGoToCredits,
    margin: "0 1em 0 0"
  }, "\u0417\u0430\u0442\u0432\u043E\u0440\u0438"), status === 'notSign' && ___EmotionJSX(Button, {
    onClick: function onClick() {
      return setStatus('sign');
    }
  }, "\u0418\u0437\u043F\u043B\u0430\u0442\u0438")))) : ___EmotionJSX(SignDocument, {
    isAfterApproval: true,
    creditId: Number(credit === null || credit === void 0 ? void 0 : credit.id),
    creditStatus: credit === null || credit === void 0 ? void 0 : credit.status,
    onNext: handleActivate
  }));
};

PayOff.propTypes = {
  credit: PropTypes.object,
  onActivate: PropTypes.func
};
export default PayOff;